import { TTreeState } from '@infotech-soe/merps/types/Queries';
import { TDatabaseId } from '@infotech-soe/metaschema';

import { CatalogsStateEntity } from '../slices/catalogs';

export class CatalogsTreeStateMarshaller {
  private ids: TDatabaseId[] = [];
  private hierarchy = false;

  constructor(private readonly tree: CatalogsStateEntity) {
    this.buildTreeState();
  }

  public getTreeState(): TTreeState {
    return {
      ids: this.ids,
      hierarchy: this.hierarchy,
    };
  }

  private buildTreeState(): void {
    if (this.isHierarchy()) {
      this.onHierarchy();
    } else if (this.isScattered()) {
      this.onScattered();
    } else if (this.isSingle()) {
      this.onSingle();
    }
  }

  private isHierarchy(): boolean {
    return this.tree.hierarchyRootId !== null;
  }

  private onHierarchy(): void {
    this.ids =
      this.tree.hierarchyRootId === this.tree.treeRootId
        ? []
        : [this.tree.hierarchyRootId ?? 0];
    this.hierarchy = true;
  }

  private isScattered(): boolean {
    return this.tree.checkedNodes.size > 0;
  }

  private onScattered(): void {
    this.ids = this.tree.checkedNodes.toArray();
    this.hierarchy = false;
  }

  private isSingle(): boolean {
    return this.tree.activeId !== null;
  }

  private onSingle(): void {
    this.ids = [this.tree.activeId ?? 0];
    this.hierarchy = false;
  }
}
